<template>
  <span>You successfully created new study with your data</span>
</template>

<script>
export default {
  name: "created-study"
};
</script>
